module.exports = __webpack_public_path__ + "img/javascript.87711407.svg";